<template>
  <img class="logo" src="/logo/artfield-logo-black.png" alt="Logo dark">
</template>

<style scoped>
.logo {
  max-width: 110px;
  margin: 24px 24px 24px 0;
  cursor: pointer;
}
</style>
<script setup lang="ts">
</script>